export default "__VITE_ASSET__BJfts_Kd__"